import QuitaCrudPage from './QuitaCrudPage'
export {QuitaCrudPage}
export default QuitaCrudPage
